import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_PREFIX } from '../../config/env';

interface EstadoAvisoSonoro {
  activo: boolean;
  alternar: () => void;
}

/**
 * Preferencia de sonido al entrar una alarma.
 *
 * Arranca encendido: quien vigila una instalación necesita enterarse aunque
 * esté en otra pestaña. Silenciarlo es una decisión consciente, y se recuerda.
 */
export const useAvisoSonoroStore = create<EstadoAvisoSonoro>()(
  persist(
    (set, get) => ({
      activo: true,
      alternar: () => set({ activo: !get().activo }),
    }),
    {
      name: `${STORAGE_PREFIX}aviso-sonoro`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
